<script setup>
import { defineProps, defineEmits} from "vue";
import CartaoDePedidoDeCompra from "./CartaoDePedidoDeCompra/CartaoDePedidoDeCompra.vue";
import CabecalhoEmailCartao from "./CabecalhoEmail/CabecalhoEmailCartao.vue";
import CorpoEmailCartao from "./CorpoEmail/CorpoEmailCartao.vue";
import AnexoEmailCartao from "./AnexoEmail/AnexoEmailCartao.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "email",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:email"
]);

//==================================================================//
//========================= Altera Email ===========================//
//==================================================================//

const alteraEmail = (update) =>{

    emits('update:email',update);

}

</script>

<template>

    <div class="c-conteudo">

        <CartaoDePedidoDeCompra
            :dado="props.pedidoDeCompra"
        ></CartaoDePedidoDeCompra>

        <CabecalhoEmailCartao
            :pedidoDeCompra="props.pedidoDeCompra"
            :email="email"
            @update:email="alteraEmail"
        ></CabecalhoEmailCartao>

        <CorpoEmailCartao
            :pedidoDeCompra="props.pedidoDeCompra"
            :email="email"
            @update:email="alteraEmail"
        ></CorpoEmailCartao>

        <AnexoEmailCartao
            :pedidoDeCompra="props.pedidoDeCompra"
            :email="email"
            @update:email="alteraEmail"
        ></AnexoEmailCartao>

    </div>

</template>

<style scoped>

.c-conteudo{
    display: grid;
    gap: 15px;
}

</style>